import React from "react";

export const InsuranceDeliveredInfo = ({ formData, handleChange, setFormData }) => {
    const { memoForInsCorp } = formData;

    return (
        <>
            {/* 메모 */}
            <div className="item-row" data-grow="1">
                <div className="row-head">
                    <span>메모</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <textarea
                            name="memoForInsCorp"
                            placeholder="메모를 작성해주세요."
                            value={memoForInsCorp || ""}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
